import { baseMessages } from "./base";
import { siemWorkflowsMessages } from "./views/siemWorkflows";
import { siemWorkflowDetailsMessages } from "./views/siemWorkflowDetails";
import { siemDashboardMessages } from "./views/siemDashboard";
import { hackwatchMessages } from "./views/hackwatch";
import { newsMessages } from "./views/news";
import { adminMessages } from "./views/admin";
import { siemMessages } from "./views/siem";
import { usersMessages } from "./views/users";
import { wizardMessages } from "./views/wizard";
import { partnerCustomersMessages } from "./views/partnerCustomers";
import { notificationsMessages } from "./views/notifications";
import { securityMessages } from "./views/security";

const mergeDeep = (target, source) => {
  if (!source) return target;
  Object.keys(source).forEach((key) => {
    const value = source[key];
    if (value && typeof value === "object" && !Array.isArray(value)) {
      if (!target[key]) target[key] = {};
      mergeDeep(target[key], value);
    } else {
      target[key] = value;
    }
  });
  return target;
};

const mergeMessages = (...tables) => {
  const output = {};
  tables.forEach((table) => {
    Object.keys(table).forEach((lang) => {
      if (!output[lang]) output[lang] = {};
      mergeDeep(output[lang], table[lang]);
    });
  });
  return output;
};

export const languageOptions = [
  { code: "en", label: "English" },
  { code: "de", label: "Deutsch" },
];

export const defaultLang = "en";
export const languageStorageKey = "aa-secsu-language";

export const messages = mergeMessages(
  baseMessages,
  siemDashboardMessages,
  siemWorkflowsMessages,
  siemWorkflowDetailsMessages,
  hackwatchMessages,
  newsMessages,
  adminMessages,
  siemMessages,
  usersMessages,
  wizardMessages,
  partnerCustomersMessages,
  notificationsMessages,
  securityMessages,
);
